import { ReviewStatusSchema as o, LandingIdSchema as l, CreativeIdSchema as u, ImageTypeSchema as x, CreativeTypeSchema as T, FilenameSchema as J, MediaUrlSchema as Z, CustomContentUrlSchema as ee, CustomContentSchema as te, CreativeVariationWeightSchema as U, AssetStatusSchema as v, AdTypeSchema as i, AssetIdSchema as V, CreativeGroupIdSchema as ne, AdFormatSchema as ae, CampaignGroupIdSchema as oe, AdFormatIdSchema as ie, AdTypeIdSchema as re, OnOffSchema as se, NumericIdSchema as ce, UserIdSchema as d, LandingGroupIdSchema as h } from "@hprofits/shared";
import { hasValue as me } from "@hprofits/utils/fp/optional";
import { z as e } from "zod";
import { createViewSchemas as b } from "../common/acl-view.js";
import "@hprofits/utils";
import "@orpc/contract";
import "@orpc/openapi";
import "../swagger/security.js";
import "../swagger/tags.js";
import { OwnerSchema as c } from "../common/owner.js";
import "../common/params.js";
import { PaginationSchema as I, SortingSchema as L, paginatedList as A } from "../common/pagination.js";
const E = 50, D = e.string().trim().min(1, "name must be non-empty").max(E, `name must be at most ${E} characters`), de = e.string().trim().min(1, "name must be non-empty"), pe = 15, g = e.string().min(pe), S = e.enum(["Fraud", "DontWork"]), B = e.object({
  rejectReason: S,
  rejectDescription: g.optional()
}), ut = e.record(S, e.string()), y = e.enum(["Misleading", "LowQuality", "Suspicious", "BadAds"]), M = e.object({
  rejectReason: y,
  rejectDescription: g.optional()
}), ht = e.record(y, e.string()), le = e.object({
  id: l,
  url: e.string(),
  // z.url(),
  status: o,
  rejection: B.optional()
}).readonly(), O = e.enum(["file", "customUrl", "customHtml"]), ue = e.object({
  id: u,
  name: e.string(),
  size: e.string().optional(),
  // TODO: Banner Size - maybe it will be better to rename and use enum here
  content: e.union([Z, ee, te]).optional(),
  contentKind: O,
  status: o,
  title: e.string().optional(),
  description: e.string().optional(),
  brandTitle: e.string().optional(),
  tagIds: e.array(e.number()).optional(),
  originalFilename: J.optional(),
  sizeBytes: e.number().optional(),
  creativeType: T.optional(),
  imageType: x.optional(),
  owner: c,
  rejection: M.optional()
}).readonly(), he = e.object({
  reviewer: c.optional()
}).readonly(), {
  common: gt,
  admin: St,
  union: ge
} = b(ue, he), Se = e.object({
  id: V,
  adType: i,
  status: v,
  weight: U,
  creative: ge.optional(),
  landing: le.optional()
}).readonly(), ye = e.object({
  creativeId: u.optional(),
  landingId: l.optional(),
  weight: U.optional()
}).strict().readonly(), yt = ye.unwrap().extend({
  id: V
}).readonly(), F = e.object({
  id: ne,
  name: de,
  status: v
}), Ce = e.record(v, e.number().int().nonnegative()), Te = F.extend({
  campaignId: oe,
  adType: i,
  adFormat: ae,
  autoRotateIsEnabled: e.boolean(),
  fraudulentTrafficUrl: e.string().min(1).optional(),
  assets: e.array(Se).readonly()
}).readonly(), ve = e.object({
  rotatorIndex: e.string().min(1).optional()
}).readonly(), {
  common: Ct,
  admin: Tt,
  union: vt
} = b(Te, ve), be = F.extend({
  assetsCount: e.number().int().nonnegative(),
  detailedStatus: Ce
}).readonly(), bt = e.array(be).readonly(), P = e.object({
  name: D,
  status: se,
  type: re,
  format: ie,
  autoRotateIsEnabled: e.boolean().optional(),
  fraudulentTrafficUrl: e.string().trim().min(1).optional()
}).strict(), w = 100, z = e.object({
  rotatorIndex: e.string().trim().min(1).max(w, `rotator index must be ${w} characters or less`).optional()
}), Ie = P.readonly(), Le = P.extend(z.shape).readonly(), It = e.union([Ie, Le]).readonly(), H = e.object({
  autoRotateIsEnabled: e.boolean().optional(),
  fraudulentTrafficUrl: e.string().trim().min(1).optional()
}).strict(), Ae = H.readonly(), Re = H.extend(z.shape).readonly(), Lt = e.union([Ae, Re]).readonly(), At = e.object({
  name: D
}).readonly(), R = e.object({
  id: l,
  status: o
}).strict(), Ge = R.extend({
  status: e.literal(o.enum.Approved)
}), fe = R.extend(B.required().shape).extend({
  status: e.literal(o.enum.Rejected)
}), je = R.extend({
  status: e.literal(o.enum.Reviewing),
  reason: g
}), Rt = e.discriminatedUnion("status", [Ge, fe, je]).readonly(), G = e.object({
  id: u,
  status: o
}).strict(), Ee = G.extend({
  status: e.literal(o.enum.Approved)
}), we = G.extend({
  status: e.literal(o.enum.Reviewing),
  reason: g
}), _e = G.extend(M.required().shape).extend({
  status: e.literal(o.enum.Rejected)
}), Gt = e.discriminatedUnion("status", [Ee, _e, we]).readonly(), r = ce.brand("AdTag"), ft = I.extend(L.shape).extend({
  id: e.array(e.coerce.number().pipe(u)).optional(),
  description: e.string().optional(),
  userId: e.array(e.coerce.number().pipe(d)).optional(),
  status: e.array(o).optional(),
  type: e.array(T).optional(),
  adType: e.array(i).optional(),
  adTags: e.array(e.coerce.number().pipe(r)).optional(),
  width: e.coerce.number().int().positive().optional(),
  height: e.coerce.number().int().positive().optional(),
  reject: e.array(y).optional(),
  labels: e.array(e.coerce.number().int()).optional(),
  uniqKey: e.string().optional()
}).readonly(), K = e.object({
  id: u,
  title: e.string().optional(),
  description: e.string().optional(),
  brandTitle: e.string().optional(),
  adType: i,
  creativeType: T.optional(),
  width: e.number().int().optional(),
  height: e.number().int().optional(),
  adTags: e.array(r).optional(),
  labelIds: e.array(e.number().int()).optional(),
  sizeBytes: e.number().int().nonnegative().optional(),
  mediaUrl: e.string().optional(),
  // The three content columns stay separate here (unlike `content` on the creative view), but which
  // one a creative carries still comes from the producer — a consumer re-deriving it drifts (#853).
  // Custom content is what the creative IS, so every persona that may pick the creative sees it.
  customContent: e.string().optional(),
  customContentUrl: e.string().optional(),
  contentKind: O,
  imageType: x.optional(),
  status: o,
  owner: c,
  uniqKey: e.string().optional(),
  rejectReason: y.optional(),
  rejectDescription: e.string().optional()
}), Ne = K.readonly(), xe = K.extend({
  reviewer: c.optional()
}).superRefine((t, n) => {
  !t.customContent && !t.customContentUrl && !t.mediaUrl && n.addIssue("at least one of customContent or mediaUrl must be specified"), me(t.mediaUrl) && t.sizeBytes === 0 && n.addIssue("size must be positive if mediaUrl is used");
}).readonly(), {
  common: jt,
  admin: Et,
  union: Ue
} = b(Ne, xe), wt = A(Ue), Ve = 50, De = 200, Be = 25, _ = {
  title: Ve,
  description: De,
  brandTitle: Be
}, Me = ["title", "description", "brandTitle"], Oe = /https?:\/\//, Fe = [i.enum.Native, i.enum.Push], $ = (t, n) => Me.flatMap((a) => {
  const s = n[a] ?? "", p = [];
  return Oe.test(s) && p.push({ field: a, code: "link", message: `${a} must not contain a link` }), Fe.includes(t) && s.length > _[a] && p.push({
    field: a,
    code: "tooLong",
    message: `${a} must be at most ${_[a]} characters`
  }), t === i.enum.Native && s.length === 0 && p.push({ field: a, code: "required", message: `${a} is required for a native creative` }), p;
}), _t = e.object({
  file: e.file(),
  adType: i,
  title: e.string().optional(),
  description: e.string().optional(),
  brandTitle: e.string().optional(),
  // Multipart fields arrive as text, hence the coercion.
  adTags: e.array(e.coerce.number().pipe(r)).optional(),
  ownerId: e.coerce.number().pipe(d).optional()
}).superRefine((t, n) => {
  for (const { field: a, message: s } of $(t.adType, t))
    n.addIssue({ code: "custom", path: [a], message: s });
}).readonly(), k = 1e5, Nt = e.object({
  title: e.string().optional(),
  description: e.string().optional(),
  brandTitle: e.string().optional(),
  adTags: e.array(r).optional(),
  content: e.string().trim().min(1).max(k).optional()
}).readonly(), Pe = [
  i.enum.Banner,
  i.enum.Video,
  i.enum.VideoSlider,
  i.enum.OutstreamVideo
], m = e.enum(["html", "vast", "url"]), ze = [
  m.enum.html,
  m.enum.url
], He = [
  m.enum.vast,
  m.enum.url
], Ke = /<[a-z]/i, $e = /<VAST[\s>]/i, ke = (t) => {
  const n = Ke.exec(t);
  return n !== null && t.includes(">", n.index + n[0].length);
}, Xe = (t, n) => t === m.enum.html ? ke(n) : t === m.enum.vast ? $e.test(n) : q.test(n) && e.url().safeParse(n).success, xt = e.object({
  adType: e.enum(Pe),
  kind: m,
  content: e.string().trim().min(1).max(k),
  description: e.string().optional(),
  adTags: e.array(r).optional(),
  bannerSizeId: e.number().int().positive().optional(),
  ownerId: d.optional()
}).superRefine((t, n) => {
  const a = t.adType === i.enum.Banner;
  (a ? ze : He).includes(t.kind) ? Xe(t.kind, t.content) || n.addIssue({ code: "custom", path: ["content"], message: `content is not valid ${t.kind}` }) : n.addIssue({
    code: "custom",
    path: ["kind"],
    message: `${t.kind} content is not accepted for ${t.adType}`
  }), a !== (t.bannerSizeId !== void 0) && n.addIssue({
    code: "custom",
    path: ["bannerSizeId"],
    message: a ? "a banner needs a size" : "only a banner has a size"
  });
  for (const { field: s, message: p } of $(t.adType, { description: t.description }))
    n.addIssue({ code: "custom", path: [s], message: p });
}).readonly(), Ut = I.extend(L.shape).extend({
  id: e.array(e.coerce.number().pipe(l)).optional(),
  name: e.string().optional(),
  userId: e.array(e.coerce.number().pipe(d)).optional(),
  status: e.array(o).optional(),
  algorithm: e.array(e.coerce.number().int()).optional(),
  landingGroup: e.array(e.coerce.number().pipe(h)).optional(),
  landingGroupName: e.string().optional(),
  url: e.string().optional(),
  adTags: e.array(e.coerce.number().pipe(r)).optional(),
  reject: e.array(S).optional(),
  automated: e.preprocess((t) => t === "true" ? !0 : t === "false" ? !1 : t, e.boolean()).optional()
}), qe = e.object({
  id: h,
  name: e.string().optional(),
  algorithm: e.number().int().optional()
}), X = e.object({
  id: l,
  name: e.string().optional(),
  url: e.string(),
  status: o,
  adTags: e.array(r).optional(),
  createdAt: e.string().optional(),
  landingGroup: qe.optional(),
  owner: c.optional(),
  reviewer: c.optional(),
  rate: e.number().int().optional(),
  rejectReason: S.optional(),
  rejectDescription: e.string().optional()
}), Qe = X.readonly(), Vt = A(Qe), N = 100, q = /^https?:\/\//i, f = e.string().trim().min(1, "url must be non-empty").regex(q, "url must start with http:// or https://"), j = e.string().trim().min(1, "name must be non-empty").max(N, `name must be at most ${N} characters`), Dt = e.object({
  name: j,
  url: f,
  ownerId: d.optional(),
  adTags: e.array(r).optional()
}).readonly(), Bt = e.object({ url: f, adTags: e.array(r).optional() }).readonly(), C = { even: 1, percent: 2 }, Q = e.union([
  e.literal(C.even),
  e.literal(C.percent)
]), W = e.object({
  url: f,
  adTags: e.array(r).optional(),
  // A relative weight, not a percentage: the ad server picks by rate / sum of rates. Ignored for Even.
  rate: e.number().int().nonnegative().optional()
}), Y = (t, n) => {
  t.algorithm === C.percent && t.landings.forEach((a, s) => {
    a.rate || n.addIssue({
      code: "custom",
      path: ["landings", s, "rate"],
      message: "rate must be greater than 0 for the Percent algorithm"
    });
  });
}, We = e.object({
  name: j,
  algorithm: Q,
  ownerId: d.optional(),
  landings: e.array(W).min(1, "a landing group needs at least one landing")
}), Mt = We.superRefine(Y).readonly(), Ye = e.object({
  name: j,
  algorithm: Q,
  landings: e.array(W.extend({ id: l.optional() })).min(1, "a landing group needs at least one landing")
}), Ot = Ye.superRefine(Y).readonly(), Je = e.enum(["id", "name", "createdAt"]), Ft = I.extend(L.shape).extend({
  sortBy: Je,
  id: e.array(e.coerce.number().pipe(h)).optional(),
  name: e.string().optional(),
  userId: e.array(e.coerce.number().pipe(d)).optional(),
  algorithm: e.array(e.coerce.number().int()).optional()
}), Ze = X.pick({
  id: !0,
  name: !0,
  url: !0,
  status: !0,
  rate: !0,
  adTags: !0,
  rejectReason: !0,
  rejectDescription: !0
}).readonly(), et = e.object({
  id: h,
  name: e.string().optional(),
  algorithm: e.number().int().optional(),
  createdAt: e.iso.datetime({ offset: !0 }),
  owner: c.optional(),
  landings: e.array(Ze).readonly()
}).readonly(), Pt = A(et);
export {
  r as AdTagSchema,
  he as ApiCreativeAdminFieldsSchema,
  St as ApiCreativeAdminViewSchema,
  ue as ApiCreativeCommonFieldsSchema,
  gt as ApiCreativeCommonViewSchema,
  ge as ApiCreativeViewSchema,
  le as ApiLandingViewSchema,
  Se as AssetViewSchema,
  Be as CREATIVE_BRAND_TITLE_MAX_LENGTH,
  De as CREATIVE_DESCRIPTION_MAX_LENGTH,
  E as CREATIVE_GROUP_NAME_MAX_LENGTH,
  Ve as CREATIVE_TITLE_MAX_LENGTH,
  Pe as CUSTOM_CONTENT_AD_TYPES,
  k as CUSTOM_CONTENT_MAX_LENGTH,
  ye as CreateAssetSchema,
  Le as CreateCreativeGroupAdminSchema,
  Ie as CreateCreativeGroupCommonSchema,
  It as CreateCreativeGroupSchema,
  Et as CreativeAdminItemSchema,
  jt as CreativeCommonItemSchema,
  O as CreativeContentKindSchema,
  _t as CreativeCreateSchema,
  xt as CreativeCustomContentCreateSchema,
  Tt as CreativeGroupAdminViewSchema,
  Ct as CreativeGroupCommonViewSchema,
  Ce as CreativeGroupDetailedStatus,
  be as CreativeGroupListItemSchema,
  bt as CreativeGroupListSchema,
  vt as CreativeGroupViewSchema,
  Ue as CreativeListItemSchema,
  ft as CreativeListQuerySchema,
  wt as CreativeListSchema,
  y as CreativeRejectReasonSchema,
  ht as CreativeRejectReasonsDictionarySchema,
  M as CreativeRejectionSchema,
  Gt as CreativeReviewSchema,
  Nt as CreativeUpdateSchema,
  m as CustomContentKindSchema,
  C as LANDING_GROUP_ALGORITHM,
  N as LANDING_NAME_MAX_LENGTH,
  Dt as LandingCreateSchema,
  Q as LandingGroupAlgorithmSchema,
  We as LandingGroupCreateBaseSchema,
  Mt as LandingGroupCreateSchema,
  Ze as LandingGroupLandingItemSchema,
  et as LandingGroupListItemSchema,
  Ft as LandingGroupListQuerySchema,
  Pt as LandingGroupListSchema,
  Je as LandingGroupSortKeySchema,
  Ye as LandingGroupUpdateBaseSchema,
  Ot as LandingGroupUpdateSchema,
  Qe as LandingListItemSchema,
  Ut as LandingListQuerySchema,
  Vt as LandingListSchema,
  S as LandingRejectReasonSchema,
  ut as LandingRejectReasonsDictionarySchema,
  B as LandingRejectionSchema,
  Rt as LandingReviewSchema,
  Bt as LandingUpdateSchema,
  At as RenameCreativeGroupSchema,
  yt as UpdateAssetSchema,
  Re as UpdateCreativeGroupAdminSchema,
  Ae as UpdateCreativeGroupCommonSchema,
  Lt as UpdateCreativeGroupSchema,
  $ as creativeTextIssues,
  Xe as isCustomContentValid,
  Y as validateLandingGroupRates
};
//# sourceMappingURL=schemas.js.map
